import { BrowserRouter } from "react-router-dom";
import { AuthListener } from "../AuthListener.jsx";
import { AuthProvider } from "../AuthContext.jsx";

export function AppProviders({ children }) {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AuthListener />
        {children}
      </AuthProvider>
    </BrowserRouter>
  );
}